import { useFormContext } from 'react-hook-form'
import { GetHcsAnnContactByIdResponseIds } from '@toktokdoctech/tokapi-client'

export const defaultValues: GetHcsAnnContactByIdResponseIds = {
    id: '',
    rppsNum: '',
    nationalId: '',
    lastName: '',
    firstName: '',
    profession: '',
    speciality: '',
    isAutoCreation: false,
    securedEmail: '',
    category: '',
}

export const useFormContextContact = useFormContext<GetHcsAnnContactByIdResponseIds>
